<template>
  <v-card elevation="1">
    <v-card-subtitle>
      <span class="headline">Extra charges</span>
    </v-card-subtitle>
    <v-card-text>
      <v-alert
        v-if="SHOW_ALERT"
        prominent
        type="error">
        <v-row align="center">
          <v-col class="grow">{{ ALERT_TEXT }}</v-col>
          <v-col class="shrink">
            <v-btn @click="accept()">Ok</v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-data-table
        hide-default-footer
        disable-pagination
        :headers="extraChargesHeaders"
        :items="items">
        <template v-slot:top>
          <v-dialog
            v-model="showExtraChargeDialog"
            max-width="350px">
            <ValidationObserver
              :disabled="true"
              ref="extraCharge"
              v-slot="{ invalid, valid, errors }">
              <v-form v-model="extraChargeValid">
                <v-card>
                  <v-card-title>
                    <span class="headline">Set new extra charge price</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            rules="required"
                            name="EffectiveToDate"
                            vid="effectiveToDate"
                            v-slot="{ errors }">
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <validation-provider
                                  name="Invalid effective to date"
                                  :rules="'required'"
                                  v-slot="{errors}" slim>
                                  <v-text-field
                                    v-model="fmtEffectiveToDate"
                                    label="Set effective to date"
                                    prepend-icon="mdi-calendar-plus"
                                    readonly
                                    :error-messages="errors"
                                    v-on="on">
                                  </v-text-field>
                                </validation-provider>
                              </template>
                              <v-date-picker
                                v-model="newEffectiveToDate"
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Set new Price"
                            vid="extraChargePrice"
                            v-slot="{ errors }">
                            <v-currency-field
                              :error-messages="errors"
                              label="Addon Price"
                              v-model="editedExtraChargeItem.price"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeExtraCharge">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveExtraCharge">
                      Done
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>
        </template>
        <template v-slot:item.name="{ item }">
            <div :class="extraChargeDeleteClass(item)">
              {{ item.name }}
            </div>
        </template>
        <template v-slot:item.price="{ item }">
            <div :class="extraChargeDeleteClass(item)">
              {{ item.price | toCurrency }}
          </div>
        </template>
        <template v-slot:item.effectiveFrom="{ item }">
            <div :class="extraChargeDeleteClass(item)">
              {{ $moment(item.effectiveFrom).format(SHORT_DATE_FORMAT) }}
            </div>
        </template>
        <template v-slot:item.effectiveTo="{ item }">
            <div :class="extraChargeDeleteClass(item)" v-if="$moment(item.effectiveTo).isValid()">
              {{ $moment(item.effectiveTo).format(SHORT_DATE_FORMAT) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="green" v-if="!item.effectiveTo || item.updated">
            <v-icon
              small
              title="Set new price and effective from/to dates"
              @click="editExtraCharge(item)">
              mdi-account-edit
            </v-icon>
          </v-btn>
          <v-btn icon color="red" v-if="item.updated">
            <v-icon
              small
              title="Record updated and ready to save">
              mdi-folder-edit
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('required', required);

export default {
  name: 'extraCharges',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    items: {
      type: Array,
    },
  },
  data: () => ({
    newEffectiveToDate: undefined,
    menu1: false,
    editedExtraChargeIndex: -1,
    editedExtraChargeItem: {},
    showExtraChargeDialog: false,
    extraChargeValid: false,
    extraChargesHeaders: [
      { text: 'Type', value: 'name' },
      { text: 'Price', value: 'price' },
      { text: 'Effective from', value: 'effectiveFrom' },
      { text: 'Effective to', value: 'effectiveTo' },
      { text: 'Actions', value: 'actions' },
    ],
  }),
  computed: {
    ...mapGetters([
      storeConstants.IS_ADMINISTRATOR,
      storeConstants.SHORT_DATE_FORMAT,
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ALERT_TEXT,
      storeConstants.SHOW_ALERT]),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
    ]),
    fmtEffectiveToDate() {
      if (!this.newEffectiveToDate) {
        return null;
      }
      return this.$moment(this.newEffectiveToDate).format(this.DISPLAY_DATE_FORMAT);
    },
  },
  methods: {
    ...mapActions([
      storeConstants.SET_ALERT_DETAILS,
    ]),
    accept() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
    },
    editExtraCharge(item) {
      this.editedExtraChargeIndex = this.items.indexOf(item);
      this.editedExtraChargeItem = Object.assign({}, item);
      this.showExtraChargeDialog = true;
    },
    extraChargeDeleteClass(item) {
      if (item.deleteFg) {
        return 'extra-charge-deleted';
      }
      return null;
    },
    closeExtraCharge() {
      this.clearExtraChargeItem();
      this.showExtraChargeDialog = false;
    },
    clearExtraChargeItem() {
      this.$nextTick(() => {
        this.editedExtraChargeItem = Object.assign({});
        this.editedExtraChargeIndex = -1;
        this.newEffectiveToDate = undefined;
      });
    },
    saveExtraCharge() {
      this.$refs.extraCharge.validate().then((success) => {
        this.extraChargeValid = success;
        if (this.extraChargeValid) {
          this.editedExtraChargeItem.updated = true;
          this.editedExtraChargeItem.effectiveTo = this.newEffectiveToDate;
          Object.assign(this.items[this.editedExtraChargeIndex], this.editedExtraChargeItem);
          this.clearExtraChargeItem();
          this.showExtraChargeDialog = false;
        }
      });
    },
  },
};
</script>

<style>
  .extra-charge-deleted {
    color: #ff0000;
    text-decoration: line-through;
  }
</style>
